export type AttemptStartHandoffState = {
  attemptPhase: 'waiting' | 'countdown' | 'attempt' | 'done';
  awaitingResult: boolean;
  readyMessage: string | null;
};

export const ROBOT_READY_MESSAGE = 'Robot ready';
export const ROBOT_PREPARING_MESSAGE = 'Robot preparing';

export const shouldKeepReadyVisibleDuringAttemptStartHandoff = (
  previousReadyMessage: string | null,
  waitReason: string | null,
  enqueuedReason: string,
): boolean => {
  const wasReady = previousReadyMessage === ROBOT_READY_MESSAGE;
  const isEnqueuedWait = waitReason === enqueuedReason;

  return wasReady && isEnqueuedWait;
};

export const shouldRecoverStalledAttemptStartHandoff = (
  state: AttemptStartHandoffState,
): boolean => {
  const isWaitingPhase = state.attemptPhase === 'waiting';

  if (!isWaitingPhase) {
    return false;
  }

  if (state.awaitingResult) {
    return false;
  }

  return state.readyMessage === ROBOT_READY_MESSAGE;
};
